var _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.14286 11.4493V6.28571C9.14286 4.70776 7.86367 3.42857 6.28571 3.42857C4.70776 3.42857 3.42857 4.70776 3.42857 6.28571V13.3211C3.69201 13.1486 4.00069 12.9681 4.3591 12.7889C5.45716 12.2399 7.01029 11.7086 9.14286 11.4493ZM10.5714 11.3239V6.28571C10.5714 3.91878 8.65265 2 6.28571 2C3.91878 2 2 3.91878 2 6.28571V17.7143C2 20.0812 3.91878 22 6.28571 22C8.65265 22 10.5714 20.0812 10.5714 17.7143V12.7548C11.0219 12.728 11.4977 12.7135 12 12.7135C12.4987 12.7135 12.9746 12.6999 13.4286 12.6745V17.7143C13.4286 20.0812 15.3474 22 17.7143 22C20.0812 22 22 20.0812 22 17.7143V6.28571C22 3.91878 20.0812 2 17.7143 2C15.3474 2 13.4286 3.91878 13.4286 6.28571V11.2436C12.978 11.2704 12.5022 11.2849 12 11.2849C11.5012 11.2849 11.0253 11.2985 10.5714 11.3239ZM14.8571 12.5491V17.7143C14.8571 19.2922 16.1363 20.5714 17.7143 20.5714C19.2922 20.5714 20.5714 19.2922 20.5714 17.7143V10.6773C20.308 10.8498 19.9993 11.0303 19.6408 11.2095C18.5428 11.7585 16.9897 12.2898 14.8571 12.5491ZM20.5714 8.86586C20.5202 8.91626 20.4549 8.97712 20.3744 9.04616C20.1049 9.27719 19.6624 9.60153 19.002 9.93176C18.0892 10.3882 16.7487 10.8613 14.8571 11.1092V6.28571C14.8571 4.70776 16.1363 3.42857 17.7143 3.42857C19.2922 3.42857 20.5714 4.70776 20.5714 6.28571V8.86586ZM9.14286 12.8892C7.25125 13.1371 5.91079 13.6102 4.99798 14.0667C4.33752 14.3969 3.89506 14.7212 3.62553 14.9522C3.54502 15.0213 3.47975 15.0821 3.42857 15.1325V17.7143C3.42857 19.2922 4.70776 20.5714 6.28571 20.5714C7.86367 20.5714 9.14286 19.2922 9.14286 17.7143V12.8892Z",
    fill: "url(#paint0_linear_10926_39546)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_10926_39546",
    x1: 22,
    y1: 2,
    x2: 2,
    y2: 22,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6DF7BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#03B0E8"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWone);
export default __webpack_public_path__ + "static/media/wone.80a37477b598c14d41f8a83669ffd7de.svg";
export { ForwardRef as ReactComponent };